import { baseQueryParams } from 'src/utils';
import { getKeyByValue } from './getKeyByValue';

type param = Partial<Record<keyof typeof baseQueryParams, string>>;

export const setCheckboxFilter = (
  filterParam: string,
  item: string,
  urlParams: Record<keyof typeof baseQueryParams, '' | string>
): param | undefined => {
  const paramKey = getKeyByValue(baseQueryParams, filterParam) as keyof typeof baseQueryParams;

  if (paramKey) {
    const currentValue = urlParams[paramKey];
    const values = currentValue ? currentValue.split(',') : [];
    const isActive = values.includes(item);

    const newValues = isActive ? values.filter((v) => v !== item) : [...values, item];

    return { [paramKey]: newValues.join(',') };
  }
};
